import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addButton", "optionPanel", "categoryOption", "categoryRow", "emptyState"]

  toggleOptions() {
    this.optionPanelTarget.classList.toggle("hidden")
  }

  add(event) {
    const category = event.currentTarget.dataset.category
    const row = this.rowFor(category)
    if (!row) return

    row.classList.remove("hidden")
    event.currentTarget.classList.add("hidden")
    this.optionPanelTarget.classList.add("hidden")
    this.updateEmptyState()

    row.querySelector("[data-lookup-selector-target='selectButton']")?.focus()
  }

  remove(event) {
    const row = event.currentTarget.closest("[data-manual-upload-exceptions-target='categoryRow']")
    if (!row) return

    this.clearLookup(row)
    row.classList.add("hidden")

    const option = this.categoryOptionTargets.find((target) => target.dataset.category === row.dataset.category)
    option?.classList.remove("hidden")

    this.updateEmptyState()
  }

  rowFor(category) {
    return this.categoryRowTargets.find((row) => row.dataset.category === category)
  }

  clearLookup(row) {
    row.querySelectorAll("[data-lookup-selector-target='hiddenInput']").forEach((hiddenInput) => {
      hiddenInput.value = ""
      hiddenInput.dispatchEvent(new Event("change", { bubbles: true }))
    })

    row.querySelectorAll("[data-lookup-selector-target='placeholder']").forEach((placeholder) => {
      placeholder.textContent = "Pasirinkite..."
      placeholder.classList.add("text-gray-500")
      placeholder.classList.remove("text-black", "font-medium")
    })
  }

  updateEmptyState() {
    const hasRows = this.categoryRowTargets.some((row) => !row.classList.contains("hidden"))
    this.emptyStateTarget.classList.toggle("hidden", hasRows)

    const hasOptions = this.categoryOptionTargets.some((option) => !option.classList.contains("hidden"))
    this.addButtonTarget.classList.toggle("hidden", !hasOptions)
  }
}
